<template>
    <b-row>
        <b-col cols="12" class="detail-data-wrapper mb-0">
            <h6 class="form-title mb-3" :class="allStatusClass">{{ allStatusLabel }}</h6>
            <b-list-group>
                <b-list-group-item v-for="item in data.dataApproval" :key="item.id">
                    <h6 class="form-title text-uppercase">{{ item.role }}</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama</b-col>
                        <b-col>{{ item.approvalBy }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status</b-col>
                        <b-col>
                            <span class="status-box-md status-box-warning" v-if="item.status == STATUS_DISBURSEMENT_APPROVAL.PENDING">Pending</span>
                            <span class="status-box-md status-box-success" v-if="item.status == STATUS_DISBURSEMENT_APPROVAL.APPROVED">Approved</span>
                            <span class="status-box-md status-box-danger" v-if="item.status == STATUS_DISBURSEMENT_APPROVAL.REJECTED">Rejected</span>
                            <span class="status-box-md status-box-danger" v-if="item.status == STATUS_DISBURSEMENT_APPROVAL.CANCELLED">Cancelled</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                        <b-col>{{ $helper.formatDateAndHour(item.updatedAt) }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                        <b-col>{{ item.reason || '-' }}</b-col>
                    </b-row>
                </b-list-group-item>
            </b-list-group>
        </b-col>
    </b-row>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'detail-metode-pencairan',
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    computed: {
        STATUS_DISBURSEMENT_APPROVAL(){
            return CONSTANTS.GADAI.STATUS_DISBURSEMENT_APPROVAL
        },
        STATUS_DISBURSEMENT_GADAI(){
            return CONSTANTS.GADAI.STATUS_DISBURSEMENT_GADAI
        },
        allStatusLabel() {
            const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
            switch (this.data.statusAll) {
                case statusDisburse.WAIT_APPROVAL:
                    return 'Menunggu Persetujuan';
                case statusDisburse.APPROVED_ALL:
                    return 'Persetujuan Lengkap';
                case statusDisburse.DISBURSED:
                    return 'Berhasil Cair';
                case statusDisburse.DANA_DITANGGUHKAN:
                    return 'Dana Ditangguhkan';
                case statusDisburse.DANA_DITANGGUHKAN_GAGAL:
                    return 'Gagal Cair';
                case statusDisburse.CEK_IT:
                    return 'Mohon Hubungi IT';
                case statusDisburse.CANCELLED:
                    return 'Dibatalkan';
                case statusDisburse.REJECTED:
                    return 'Ditolak';
                default:
                    return '-';
            }
        },
        allStatusClass() {
            const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
            switch (this.data.statusAll) {
                case statusDisburse.WAIT_APPROVAL:
                    return 'status-wait';
                case statusDisburse.APPROVED_ALL:
                    return 'status-approved';
                case statusDisburse.DISBURSED:
                    return 'status-disbursed';
                case statusDisburse.DANA_DITANGGUHKAN:
                    return 'status-wait';
                case statusDisburse.DANA_DITANGGUHKAN_GAGAL:
                    return 'status-rejected';
                case statusDisburse.CEK_IT:
                    return 'status-rejected';
                case statusDisburse.CANCELLED:
                    return 'status-cancelled';
                case statusDisburse.REJECTED:
                    return 'status-rejected';
                default:
                    return '';
            }
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return '-'

            return `${this.$helper.changeDateFormat(item.updatedAt)} ${this.$helper.changeDateFormatGetHour(item.updatedAt)}`
        }
    }
}
</script>
